// extracted by mini-css-extract-plugin
module.exports = {"grey400":"#7D7D84","blue300":"#14267B","label":"Checkbox_label__yC4kR","checkbox":"Checkbox_checkbox__D7Yew"};